const themeConfigApi = ({ apiClient }) => ({
  pagesResources: {
    show() {
      return apiClient.get(`real-estates/theme-config/pages-resources`)
    },
    store(payload) {
      return apiClient.put(`real-estates/theme-config/pages-resources`, { ...payload })
    },
  },
})

export default themeConfigApi
